<template>
  <div class="homecontent" @wheel="changefix">
    <transition
      appear
      name="animate__animated animate__bounce"
      enter-active-class="animate__slideInDown"
      leave-active-class="animate__fadeOutUp"
    >
      <Header v-show="isshow" :isshow="isshow" :isShowWenKU="isfix"></Header>
    </transition>
    <div class="content" ref="homepage">
      <!-- <div class="copyright"> -->
      <div class="srolldown">
        <img
          class="tobottom"
          @click="changefix"
          src="/static/newhome/icon/down1.png"
          alt=""
        />
      </div>
      <!-- <p>大倉文庫 版權所有@北京大學出版社</p>
      </div> -->
    </div>
    <!-- <transition name="wen">
      <WenKu v-show="isfix" :isfix="isfix"></WenKu>
    </transition> -->
  </div>
</template>

<script>
import Header from '../../components/newheader.vue'
// import WenKu from "../../pages/wenku"
// import NewHeader from "../../components/newheader"
// import Header from '../../components/header.vue'
export default {
  name: 'NewHome',
  components: { Header },
  data () {
    return {
      isfix: false,
      isshow: true,
      isWenKu: true,

      // transheight: 0,
      // scrollheight: 0,
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.changefix)
    // this.transheight = (this.$refs.homepage.offsetHeight - 100) + 'px'
    // this.scrollheight = document.documentElement.scrollTop + 100
    // this.changeshow()
  },
  methods: {
    clickchangefix () {
      // this.isfix = true
      this.changeshow()
    },
    changefix (e) {
      // console.log(e)
      // const n = document.documentElement.scrollTop
      // if (n > 60) {
      //   this.isfix = true
      //   // this.isWenKu = false
      //   // setTimeout(function () {
      //   // }, 5000)
      //   // this.isWenKu = true

      // } else {
      //   this.isfix = false
      // }

      // console.log("xxx")
      // const n = document.documentElement.scrollTop
      // if (this.isfix) {
      //   if (e.wheelDelta || e.detail) {
      //     if (e.wheelDelta > 0 || e.detail < 0) {     //当鼠标滚轮向上滚动时
      //       if (n < 100) {
      //         this.isfix = false
      //         this.changeshow()
      //       }


      //     }
      //   }
      // }

      // if (!this.isfix) {
      //   if (e.wheelDelta || e.detail) {
      //     // if (e.wheelDelta > 0 || e.detail < 0) {     //当鼠标滚轮向上滚动时
      //     //   console.log("向上")

      //     // }
      //     if (e.wheelDelta < 0 || e.detail > 0) {     //当鼠标滚轮向下滚动时

      //       this.isfix = true
      //       this.changeshow()

      //       // this.$refs.wenku.style.transform = translateY(-height)
      //     }
      //   }
      // }
      this.$router.push('./wenku')


    },
    changeshow () {
      let _this = this
      this.isshow = false
      setTimeout(function () {
        _this.isshow = true
      }, 500)
    }
  }

}
</script>

<style scoped lang="less">
@import url(../../pages/newcommon.css);
html {
  font-size: 16px;
}
.wen-enter-active {
  animation: wenku 0.6s ease-in;
}
.wen-leave-active {
  animation: wenku 0.6s ease-in reverse;
}
@keyframes wenku {
  from {
    transform: translateY(1000px);
    // top: 1000px;
  }
  to {
    transform: translateY(0px);
    // top: 0px;
  }
}
.trans {
  transform: translateY("300");
}
/deep/.el-dropdown-menu {
  padding: 0;
}
/deep/.el-dropdown-menu__item {
  line-height: 1;
  padding: 0 10px;
  button {
    cursor: pointer;
  }
}
.fix {
  z-index: -9999;
  position: fixed;
  // left: 0;
  // top: 0;
  // opacity: 0;
}
.homecontent {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  // transition: all 2s ease-in-out;
  // min-height: 100vh;
  z-index: -999;
  background: url("/static/newhome/bg.jpg") no-repeat center;
  background-size: cover;
  // overflow: hidden;
  .content {
    padding: 40px 116px;
    width: 100%;
    height: 100%;
    // z-index: -9999;
    opacity: 1;

    position: relative;

    // text-align: center;
    // display: flex;
    // justify-content: flex-end;

    // position: fixed;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;

    // align-self: center;
    // justify-content: space-between;

    // .copyright {
    //   width: 100%;
    //   text-align: center;
    //   color: #fff;
    //   font-size: 16px;
    .srolldown {
      width: 100%;
      height: 70px;
      text-align: center;
      // margin-bottom: 0;
      position: absolute;
      left: 0;
      bottom: 56px;

      img {
        width: 27px;
        height: 48px;
        // position: absolute;
        // left: 49.85%;
        // bottom: 0;
        // position: absolute;
        cursor: pointer;
        // .tobottom {
        animation: mymovetwo 2s ease-in-out infinite;
        // }
      }
    }
    // }
    @keyframes mymovetwo {
      // from {
      //   // top: 0px;
      //   opacity: 0;
      // }
      // to {
      //   // top: 10px;
      //   opacity: 1;
      //   transform: translateY(10px);
      // }
      0% {
        transform: translate(0, -10px);
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        transform: translate(0, 10px);
        opacity: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue